import { Redirect, Route, RouteProps } from 'react-router';
import React from 'react';
import { useProtectedRouteSession } from './hooks/useProtectedRouteSession';

const PrivateRoute: React.FC<RouteProps> = (props) => {
  const sessionStatus = useProtectedRouteSession('PrivateRoute');

  return (
    <Route
      render={(innerProps) => {
        if (sessionStatus === 'allowed') {
          return <Route {...props} />;
        }
        if (sessionStatus === 'checking') {
          return null;
        }
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: innerProps.location },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
